import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import FiltersService from 'cio/services/filters';
import IndexController from 'cio/pods/segments/segment/overview/index/controller';
import SegmentModel from 'cio/models/segment';
import Transition from '@ember/routing/-private/transition';

export default class IndexRoute extends Route {
  @service filters!: FiltersService;

  model() {
    return this.modelFor('segments.segment');
  }

  setupController(controller: IndexController, model: SegmentModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.extractConditionTree();
  }
}
